import React, { useState, useEffect, useMemo } from 'react';
import './App.css';
import ChatInterface from './components/ChatInterface';
import { initKeycloak, getUserInfo, logout } from './services/keycloak';
import { appConfig } from './config/appConfig';
import logoPurple from './assets/Logo Purple.png';

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState<any>(null);
  const themeStyles = useMemo(
    () =>
      ({
        '--app-accent': appConfig.colors.accent,
        '--app-accent-alt': appConfig.colors.accentAlt,
        '--app-bg-image': `url(${logoPurple})`,
      }) as React.CSSProperties,
    []
  );

  useEffect(() => {
    document.title = `${appConfig.name} | QeM SDK Chat`;
    document.body.dataset.appId = appConfig.id;
    document.documentElement.style.setProperty(
      '--app-accent',
      appConfig.colors.accent
    );
    document.documentElement.style.setProperty(
      '--app-accent-alt',
      appConfig.colors.accentAlt
    );
  }, []);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const authResult = await initKeycloak();
        setAuthenticated(authResult);
        
        if (authResult) {
          const user = getUserInfo();
          setUserInfo(user);
        }
      } catch (error) {
        console.error('Failed to initialize Keycloak:', error);
        setAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const handleLogout = () => {
    logout();
    setAuthenticated(false);
    setUserInfo(null);
  };

  if (isLoading) {
    return (
      <div
        className="App"
        data-app-id={appConfig.id}
        style={themeStyles}
      >
        <div className="loading-state">
          <div className="loading-spinner" />
          <span>Initializing secure connection...</span>
        </div>
      </div>
    );
  }

  if (!authenticated || !userInfo) {
    return (
      <div
        className="App"
        data-app-id={appConfig.id}
        style={themeStyles}
      >
        <div className="redirect-state">
          <div className="loading-spinner" />
          <span>Redirecting to secure login...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="App" data-app-id={appConfig.id} style={themeStyles}>
      <ChatInterface 
        clientId={userInfo.id} 
        username={userInfo.username || userInfo.id}
        onLogout={handleLogout} 
        appName={appConfig.name}
        appTagline={appConfig.tagline}
      />
    </div>
  );
};

export default App;

